import React, { useState, useContext, Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import { LanguagePopoverContentOnCreateProfilePage } from 'app/home/overlay-pages/setting/AppSettings';
import { useLocalizedStrings, LocalizationContext } from 'app/localization/Context';

import { ReactComponent as IconHinava } from 'images/general/hinava.svg';
import { ReactComponent as IconLanguage } from 'images/profile/language.svg';
import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconSolo } from 'images/general/solo.svg';
import { ReactComponent as IconHome } from 'images/general/home.svg';

import { ReactComponent as Avatar1 } from 'images/profile/avatar-1.svg';
import { ReactComponent as Avatar2 } from 'images/profile/avatar-2.svg';
import { ReactComponent as Avatar3 } from 'images/profile/avatar-3.svg';
import { ReactComponent as Avatar4 } from 'images/profile/avatar-4.svg';
import { ReactComponent as Avatar5 } from 'images/profile/avatar-5.svg';
import { ReactComponent as Avatar6 } from 'images/profile/avatar-6.svg';

import { ReactComponent as HomeAvatar1 } from 'images/home/white/homes-1.svg';
import { ReactComponent as HomeAvatar2 } from 'images/home/white/homes-2.svg';
import { ReactComponent as HomeAvatar3 } from 'images/home/white/homes-3.svg';
import { ReactComponent as HomeAvatar4 } from 'images/home/white/homes-4.svg';
import { ReactComponent as HomeAvatar5 } from 'images/home/white/homes-5.svg';

import '../Background.scss'

export default function ChooseHomeType({ showWelcome, canDismiss, dismiss, setHomeType }) {
    const l = useContext(LocalizationContext);
    const s = useLocalizedStrings();

    const [isChooseLanguagePageActive, setChooseLanguagePageActive] = useState(false);

    return (
        <div className="new-home-flow-page"
            dir={l.isRTL ? "rtl" : "ltr"}
            lang={l.language}>
            <div className="bg-blank" />
            <div className="bg-secondary-color" />

            <div className="new-home-flow-main-content">

                {showWelcome ?
                    <Fragment>
                        <div className="change-lang" onClick={() => { setChooseLanguagePageActive(true) }} >
                            <div className="label">{s.changeLanguage}</div>
                            <IconLanguage className="icon" />
                        </div>

                        <div className="welcome-label">{s.welcome}</div>
                        <IconHinava className="hinava-icon" />
                        <div className="info-label">{s.selectHomeTypeInfoPlease}</div>
                    </Fragment> :
                    <Fragment>
                        {canDismiss ?
                            <Fragment>
                                <IconX className="nav-icon" />
                                <div className="nav-button" onClick={dismiss} />
                            </Fragment> : null}
                        <div className="page-header with-double-margin-bottom">{s.selectHomeTypeInfo}</div>
                    </Fragment>
                }


                <div className='home-type' onClick={() => setHomeType("hub")}>
                    <IconHome className='main-icon' />
                    <div className='title'>{s.homeType.hub}</div>
                    <div className='info'>{s.homeType.hubInfo}</div>
                    <IconBack className="next-icon" />
                </div>

                <div className='home-type' onClick={() => setHomeType("solo")}>
                    <IconSolo className='main-icon' />
                    <div className='title'>{s.homeType.solo}</div>
                    <div className='info'>{s.homeType.soloInfo}</div>
                    <IconBack className="next-icon" />
                </div>

                <ChooseLanguage
                    isActive={isChooseLanguagePageActive}
                    setFullLanguage={l.setFullLanguage}
                    dismiss={() => setChooseLanguagePageActive(false)} />
            </div>
        </div>
    )
}

export function ChooseLanguage({ isActive, dismiss, setFullLanguage }) {
    return (
        <AnimatePresence mode='wait'>
            {
                !isActive ? null :
                    (
                        <AnimationContainer key="new-home-flow-choose-avatar">
                            <LanguagePopoverContentOnCreateProfilePage
                                setFullLanguage={setFullLanguage}
                                dismissHandler={dismiss} />
                        </AnimationContainer>
                    )
            }
        </AnimatePresence>
    );
}

export function ChooseAvatar({ bgClassName, isActive, dismiss, setAvatar, forHome }) {
    const s = useLocalizedStrings();

    return (
        <AnimatePresence mode='wait'>
            {
                !isActive ? null :
                    (
                        <AnimationContainer key="new-home-flow-choose-avatar">
                            <div className="new-home-flow-overlay-page-content">
                                <div className="bg-blank" />
                                <div className={bgClassName} />
                                <div className="back-button" onClick={dismiss} />
                                <div className="main">
                                    <IconBack className="back" />
                                    <div className="label">{s.selectAvatar}</div>
                                    {forHome ? <div className="list">
                                        <HomeAvatar1 className="icon"
                                            onClick={() => { setAvatar(1); dismiss() }} />
                                        <HomeAvatar2 className="icon"
                                            onClick={() => { setAvatar(2); dismiss() }} />
                                        <HomeAvatar3 className="icon"
                                            onClick={() => { setAvatar(3); dismiss() }} />
                                        <HomeAvatar4 className="icon"
                                            onClick={() => { setAvatar(4); dismiss() }} />
                                        <HomeAvatar5 className="icon"
                                            onClick={() => { setAvatar(5); dismiss() }} />
                                    </div> : <div className="list">
                                        <Avatar1 className="icon"
                                            onClick={() => { setAvatar(1); dismiss() }} />
                                        <Avatar2 className="icon"
                                            onClick={() => { setAvatar(2); dismiss() }} />
                                        <Avatar3 className="icon"
                                            onClick={() => { setAvatar(3); dismiss() }} />
                                        <Avatar4 className="icon"
                                            onClick={() => { setAvatar(4); dismiss() }} />
                                        <Avatar5 className="icon"
                                            onClick={() => { setAvatar(5); dismiss() }} />
                                        <Avatar6 className="icon"
                                            onClick={() => { setAvatar(6); dismiss() }} />
                                    </div>}
                                    <div />
                                </div>
                            </div>
                        </AnimationContainer>
                    )
            }
        </AnimatePresence>
    );
}


const animationPageVariantsRTL = {
    initial: {
        translateX: "-200%"
    },
    animate: {
        translateX: "-100%"
    },
    exit: {
        translateX: "-200%"
    }
};
const animationPageVariantsLTR = {
    initial: {
        translateX: "0%"
    },
    animate: {
        translateX: "-100%"
    },
    exit: {
        translateX: "0%"
    }
};

const animationTransition = {
    duration: 0.5,  // overlay-animation-duration
    ease: "easeInOut"
}
function AnimationContainer(props) {
    const l = useContext(LocalizationContext);

    return (
        <motion.div
            initial="initial"
            animate="animate"
            exit="exit"
            variants={l.isRTL ? animationPageVariantsRTL : animationPageVariantsLTR}
            transition={animationTransition}

            className="new-home-flow-overlay-page"
        >
            {props.children}
        </motion.div>
    );
}
